import { ToastService } from 'src/app/services/toast.service';
import { ContenidoStatus } from './../../../../../common/contenido';
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContenidoPageRequested, ContenidoActionTypes, ContenidoPageLoaded, ContenidoPageCancelled, ContenidoPageRight } from './contenido.actions';
import { mergeMap, map, withLatestFrom, catchError, switchMap } from 'rxjs/operators';
import { ContenidoService } from '../../services/contenido.service';
import { Store, Action } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { of, Observable } from 'rxjs';
import { contenidoNextPageNum, contenidoPageSize, contenidoStatus } from './contenido.selectors';

@Injectable()
export class ContenidoEffects {

	loadContenido$ = createEffect( () => {
		return this.actions$.pipe(
			ofType<ContenidoPageRequested>( ContenidoActionTypes.ContenidoPageRequested ),
			switchMap( action => {
				return this.service.findGeneralStatus().pipe(
					map( remoteStatus => {
						return { action, remoteStatus };
					}),
					catchError( error => of( { action, remoteStatus: null } ) )
				);
			}),
			withLatestFrom( this.store.select( contenidoStatus ), this.store.select( contenidoNextPageNum ), this.store.select( contenidoPageSize ) ),
			switchMap( ([ data, localStatus, nextPageNum, pageSize ]) => {
				let resultAction: Observable<Action>;
				let remoteStatus: ContenidoStatus = data["remoteStatus"];
				let shouldLoadMoreContent: boolean = data["action"]["payload"]["shouldLoadMoreContent"];
				let cleared: boolean = false;

				if( remoteStatus == null ) {
					resultAction = of( new ContenidoPageCancelled( { status: null } ) );
					this.toastService.danger( "No se pudo obtener el estado de las noticias" );
				} else {
					// Hay actualizaciones nuevas?
					if(
						( localStatus && localStatus.lastUpdate && localStatus.qty >= 0 ) &&
						( localStatus.lastUpdate.getTime() != remoteStatus.lastUpdate.getTime() || localStatus.qty != remoteStatus.qty )
					) {
						nextPageNum = 0;
						cleared = true;
					}

					// Se carga el componente por primera vez?
					if( !localStatus )
						shouldLoadMoreContent = true;

					if( remoteStatus.qty == 0 ) {
						resultAction = of( new ContenidoPageLoaded({ cleared, status: remoteStatus, nextPageNum, contenido: [] }) );
					} else if( cleared || shouldLoadMoreContent ) {
						resultAction = this.service.findGeneralByPage( { pageNum: nextPageNum, pageSize } )
							.pipe(
								map( contenido => {
									let action: Action;
									// Contenido debería siempre tener elementos en esta instancia =>
									// dado que remoteStatus.qty > 0
									if( contenido.length == 0 ) {
										action = new ContenidoPageCancelled( { status: localStatus } )
									} else {
										++nextPageNum;
										action = new ContenidoPageLoaded( { cleared, status: remoteStatus, nextPageNum, contenido } );
									}
									return action;										
								}),
								catchError( error => {
									// Si no pude recuperar los nuevos contenidos, me quedo con el status local, no actualizo al nuevo (remoteStatus)
									// El status y los contenidos del store deben estar sincronizados
									this.toastService.danger( "No se pudieron obtener noticias" );
									return of( new ContenidoPageCancelled( { status: localStatus } ) );
								})
							);
					} else {
						// No hubieron cambios en los contenidos
						resultAction = of( new ContenidoPageRight() );
					}
				}

				return resultAction;
			})
		);
	});


	constructor( private actions$: Actions, private store: Store<AppState>, private service: ContenidoService, private toastService: ToastService ) {
	}

}